module.exports = __webpack_public_path__ + "img/fellow-anim.21a9fbb4.png";